import React, { useState, useEffect, useRef } from "react";
import { FaUserCircle, FaSignOutAlt, FaChevronDown } from "react-icons/fa";
import LanguageSelector from "./LanguageSelector";
import { useTranslation } from "react-i18next";

const AdminNavbar: React.FC = () => {
  const { t } = useTranslation()
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [userName, setUserName] = useState<string | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Read the user's name from localStorage on mount
    const storedName = localStorage.getItem("name");
    if (storedName) setUserName(storedName);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("name");
    localStorage.removeItem("role");
    localStorage.removeItem("lang");
    window.location.href = "/login";
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav className="bg-white text-brand-gray px-6 py-3 shadow-sm flex justify-end items-center border-b border-gray-100 font-montserrat">
      <div className="flex items-center gap-4">
        <LanguageSelector />
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="flex items-center gap-2 px-4 py-2 rounded-lg text-brand-gray hover:bg-brand-50 hover:text-brand-600 transition-colors font-semibold"
          >
            <FaUserCircle className="text-2xl text-brand-500" />
            <span className="hidden sm:inline-block">{userName || "User"}</span>
            <FaChevronDown className="text-sm text-brand-400" />
          </button>
          {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-44 bg-white rounded-xl shadow-lg z-50 overflow-hidden border border-gray-100">
              <button
                onClick={handleLogout}
                className="flex items-center w-full px-4 py-3 text-sm text-brand-gray hover:bg-brand-50 hover:text-brand-600 transition-colors"
              >
                <FaSignOutAlt className="mr-2 text-2xl text-brand-500" /> {t(`logout`)}
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;
